/**
 * @Author: qingliu
 * @Date: 2018-07-19 17:46:41.048
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-02-28 19:54:29
 */

import {axios as http} from '@yqg/resource';

import Vue from 'ssr-common/vue';

import component from 'instacash/common/component';

Vue.use(component);

export default {
    name: 'Instacash',

    data() {
        return {
            reqCount: 0
        };
    },

    computed: {
        isRequesting() {
            const vm = this;

            return vm.reqCount > 0;
        }
    },

    methods: {
        initHttpInterceptor() {
            const vm = this;
            http.interceptors.request.use(
                req => {
                    vm.reqCount += 1;

                    return req;
                },
                err => Promise.reject(err)
            );
            http.interceptors.response.use(
                res => {
                    vm.reqCount -= 1;

                    return res;
                },

                err => Promise.reject(err)
            );
        }
    },

    mounted() {
        const vm = this;
        vm.initHttpInterceptor();

        vm.$store.commit('finance/loadFinance');
    }
};
